import {
    EpgProgram,
    RBChannel,
    RBProgram,
} from 'store/railsBuilder/reducer.types';
import { RecordingMetadata } from 'store/recordings/reducer.types';

import { VodEditorial } from 'services/data-manager/types';

enum TrickModeType {
    PAUSE = 'PAUSE',
    FASTFORWARD = 'FASTFORWARD',
    REWIND = 'REWIND',
}

type TrickModesControl = {
    pauseAllowed: boolean;
    fastforwardAllowed: boolean;
    rewindAllowed: boolean;
};

export type TrickModesByPlaybackType = {
    live: TrickModesControl;
    vod: TrickModesControl;
    recording: TrickModesControl;
};

const PAUSE_ALLOWED_VALUES = ['1', '3', '5', '7'];
const FASTFORWARD_ALLOWED_VALUES = ['4', '5', '6', '7'];
const REWIND_ALLOWED_VALUES = ['2', '3', '6', '7'];

const TRICK_MODE_TYPE_TO_VALUES = {
    [TrickModeType.PAUSE]: PAUSE_ALLOWED_VALUES,
    [TrickModeType.FASTFORWARD]: FASTFORWARD_ALLOWED_VALUES,
    [TrickModeType.REWIND]: REWIND_ALLOWED_VALUES,
};

function isTrickModeAllowed(
    trickModeType: TrickModeType,
    channelTrickModeControl: string | undefined,
    assetTrickModeControl: string | undefined,
) {
    const allowedValues = TRICK_MODE_TYPE_TO_VALUES[trickModeType];

    if (assetTrickModeControl != null) {
        return allowedValues.includes(assetTrickModeControl);
    }

    if (channelTrickModeControl) {
        return allowedValues.includes(channelTrickModeControl);
    }

    return true;
}

function getAssetTrickmodesControl(
    channel: RBChannel | undefined,
    asset:
        | EpgProgram
        | RBProgram
        | VodEditorial
        | RecordingMetadata
        | undefined,
): TrickModesByPlaybackType {
    const {
        clientLiveTrickModeControl,
        clientVODTrickModeControl,
        clientRecordingTrickModeControl,
    } = channel?.editorial || {};

    return {
        live: {
            pauseAllowed: isTrickModeAllowed(
                TrickModeType.PAUSE,
                clientLiveTrickModeControl,
                asset?.clientLiveTrickModeControl,
            ),
            fastforwardAllowed: isTrickModeAllowed(
                TrickModeType.FASTFORWARD,
                clientLiveTrickModeControl,
                asset?.clientLiveTrickModeControl,
            ),
            rewindAllowed: isTrickModeAllowed(
                TrickModeType.REWIND,
                clientLiveTrickModeControl,
                asset?.clientLiveTrickModeControl,
            ),
        },
        vod: {
            pauseAllowed: isTrickModeAllowed(
                TrickModeType.PAUSE,
                clientVODTrickModeControl,
                asset?.clientVODTrickModeControl,
            ),
            fastforwardAllowed: isTrickModeAllowed(
                TrickModeType.FASTFORWARD,
                clientVODTrickModeControl,
                asset?.clientVODTrickModeControl,
            ),
            rewindAllowed: isTrickModeAllowed(
                TrickModeType.REWIND,
                clientVODTrickModeControl,
                asset?.clientVODTrickModeControl,
            ),
        },
        recording: {
            pauseAllowed: isTrickModeAllowed(
                TrickModeType.PAUSE,
                clientRecordingTrickModeControl,
                asset?.clientRecordingTrickModeControl,
            ),
            fastforwardAllowed: isTrickModeAllowed(
                TrickModeType.FASTFORWARD,
                clientRecordingTrickModeControl,
                asset?.clientRecordingTrickModeControl,
            ),
            rewindAllowed: isTrickModeAllowed(
                TrickModeType.REWIND,
                clientRecordingTrickModeControl,
                asset?.clientRecordingTrickModeControl,
            ),
        },
    };
}

export default getAssetTrickmodesControl;
